import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {ContentUsage, Dialog} from 'classes/dialog';
import {TargetGroup} from 'shared/models/target-groups/target-group';
import {DialogsOverviewRepository} from '../repositories/dialogs-overview.repository';

@Injectable()
export class DialogsOverviewService {

  constructor(private dialogsOverviewRepository: DialogsOverviewRepository) { }

  public getAllDialogs(): Observable<Array<Dialog>> {
    return this.dialogsOverviewRepository.getAllDialogs();
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    return this.dialogsOverviewRepository.getAllTargetGroups();
  }

  public deleteDialog(id: string): Observable<Response> {
    return this.dialogsOverviewRepository.deleteDialog(id);
  }

  public cloneDialogs(dialogIds: Array<String>, targetGroupId: String, deltaDays: String): Observable<Array<Dialog>> {
    return this.dialogsOverviewRepository.cloneDialogs(dialogIds, targetGroupId, deltaDays);
  }

  public getContentUsages(id: string): Observable<Array<ContentUsage>> {
    return this.dialogsOverviewRepository.getContentUsages(id);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dialogs/dialogs-overview/services/dialogs-overview.service.ts